import { render, staticRenderFns } from "./GalleryListComponent.vue?vue&type=template&id=a867d8a6&scoped=true&"
import script from "./GalleryListComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a867d8a6",
  null
  
)

export default component.exports